import httpClient from './httpClient';
import { parseApiError } from '../utils/errorHandler';

function normalizeEmail(email) {
    return String(email || '').trim();
}

async function blockByEmail(email) {
    const normalizedEmail = normalizeEmail(email);
    const response = await httpClient.patch(`/usuarios/bloqueio?email=${encodeURIComponent(normalizedEmail)}`);
    if (!response.ok) {
        throw await parseApiError(response);
    }
}

async function unblockByEmail(email) {
    const normalizedEmail = normalizeEmail(email);
    const response = await httpClient.patch(`/usuarios/desbloqueio?email=${encodeURIComponent(normalizedEmail)}`);
    if (!response.ok) {
        throw await parseApiError(response);
    }
}

const userService = {
    blockByEmail,
    unblockByEmail,
};

export default userService;
